module.exports = __webpack_public_path__ + "static/img/nc-jp.d629f53.svg";